import { SpaComponentPropsRequest } from '@chewy/header-footer-common/dist/spa/spa.util';

export const SOURCE_HEADER_COMPONENT_PROPS_REQUEST = {
  componentType: 'header',
  baseURL: `${process.env.HEADER_FOOTER_SPA_URL}`,
  csr: false,
  pageType: 'home',
  serviceName: 'chewy'
} as SpaComponentPropsRequest;

export const SOURCE_FOOTER_COMPONENT_PROPS_REQUEST = {
  componentType: 'footer',
  baseURL: `${process.env.HEADER_FOOTER_SPA_URL}`,
  csr: true,
  pageType: 'home',
  serviceName: 'chewy'
} as SpaComponentPropsRequest;

export const DEFAULT_OHC_CATEGORY_IDS_MAP = {
  'orders-payments-and-promotions': 3454,
  'shipping-and-tracking': 3455,
  'account': 3456,
  'returns': 3457,
  'autoship': 3458,
  'chewy': 3459,
  'prescriptions': 3460,
  'health-services': 3461,
  'give-back': 3462,
  'get-real': 3463,
  'managing-prescriptions-and-veterinary-diets': 3478,
  'chewy-vet-care': 3481,
  'payments': 3465
};
